'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearSyncedInterval = exports.setSyncedInterval = undefined;

require('./polyfill');

var setSyncedInterval = exports.setSyncedInterval = function setSyncedInterval(fn, timeout) {
  var animationFrameId = void 0;
  var then = Math.floor(Date.now() / timeout);

  var tick = function tick() {
    animationFrameId = global.requestAnimationFrame(tick);

    var now = Math.floor(Date.now() / timeout);
    if (then < now) {
      then = now;
      fn();
    }
  };

  tick();
  return function () {
    return global.cancelAnimationFrame(animationFrameId);
  };
};

var clearSyncedInterval = exports.clearSyncedInterval = function clearSyncedInterval(cancelFn) {
  return cancelFn && cancelFn();
};